import React from 'react';
export function Footer() {
  return <footer className="w-full bg-neutral-900 text-neutral-400 py-12 px-6" data-id="element-8">
      <div className="max-w-7xl mx-auto flex flex-col md:flex-row justify-between items-center" data-id="element-9">
        <div className="mb-4 md:mb-0" data-id="element-10">
          <span className="text-white font-medium text-lg tracking-wide" data-id="element-11">
            Stasis Studio
          </span>
        </div>
        <div className="flex gap-8 text-sm" data-id="element-12">
          <a href="#" className="hover:text-white transition-colors" data-id="element-13">
            Work
          </a>
          <a href="#" className="hover:text-white transition-colors" data-id="element-14">
            Process
          </a>
          <a href="#" className="hover:text-white transition-colors" data-id="element-15">
            Contact
          </a>
        </div>
        <div className="mt-8 md:mt-0 text-xs text-neutral-600" data-id="element-16">
          © {new Date().getFullYear()} Stasis Studio. All rights reserved.
        </div>
      </div>
    </footer>;
}